import { StoreState } from '@/redux/types';
import { getBasketItem } from './getBasketItem';
import { getBasketItemsByProductId } from './getBasketItemsByProductId';

export const getAllBasketItemsWithSameProductId = (state: StoreState, basketItemId: string) =>
  getBasketItemsByProductId(state, getBasketItem(state, basketItemId)?.productId);
